module.exports = __webpack_public_path__ + "static/media/footrise-30.2f187341.png";